
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import { ellipsisString, whatsapp, formatByCountry } from "@/app/infrastructures/misc/Utils";
import TableDetail from "../detail/table-detail.vue";
import { Pagination } from "@/domain/entities/Pagination";
import { PickupDashboardController } from "@/app/ui/controllers/PickupDashboardController";
import { formatDate } from "@/app/infrastructures/misc/Utils";
import { ShipmentListRequest } from "@/data/payload/api/PickupDashboardRequests";
import ErrorMessage from "@/app/ui/components/error-message/index.vue";
import { INTERNAL_SERVER_ERROR as INTERNAL_SERVER_ERROR_CONST } from "@/app/infrastructures/misc/Constants";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";

@Options({
  components: { TableDetail, ErrorMessage }
})
class PickupDashboardMonitoringCourierDetailCRRPIC extends Vue {
  INTERNAL_SERVER_ERROR = INTERNAL_SERVER_ERROR_CONST as string;
  formatPhoneNumber = formatPhoneNumber;
  sortBy = "status_at" as string;
  sortDir = "desc" as "asc" | "desc" | "";
  pagination = new Pagination(1, 20, 0);
  listData: any[] = [];
  isLoading = false;
  error = "" as string;
  filterStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  filterEnd = new Date();
  showImagePreview = false;
  images: Array<{ image: string; url: string }> = [];
  image = "" as string;
  lastFetchKey = "";
  pendingKey = "";
  readyForUserSort = false;

  get selectedCount() {
    try {
      return (this.listData || []).filter((d: any) => Boolean(d.is_checked))
        .length;
    } catch (_) {
      return 0;
    }
  }
  get columns() {
    return [
      { key: "checkbox", name: "", styleHead: "w-10 text-left" },
      {
        key: "no",
        name: "pickupDashboard.column.no",
        styleHead: "w-16 text-left"
      },
      {
        key: "shipment_id",
        name: "pickupDashboard.column.shipmentId",
        render: undefined
      },
      {
        key: "sender_name",
        name: "pickupDashboard.column.senderName",
        sortable: true
      },
      {
        key: "shipment_type",
        name: "pickupDashboard.column.shipmentType",
        render: undefined
      },
      {
        key: "total_quantity",
        name: "pickupDashboard.column.totalKoli",
        sortable: true
      },
      {
        key: "status_at",
        name: "pickupDashboard.column.pickUpDate",
        sortable: true
      },
      {
        key: "bukti_pickup",
        name: "pickupDashboard.column.pickUpProof",
        styleHead: "text-center",
        styleCustom: "justify-center",
        render: undefined
      },
      {
        key: "booking",
        name: "pickupDashboard.column.booking",
        styleHead: "text-center",
        styleCustom: "justify-center",
        render: undefined
      }
    ];
  }

  get selectedEligibleCount() {
    try {
      return (this.listData || []).filter(
        (d: any) => Boolean(d.is_checked) && d?.is_able_to_booking !== false
      ).length;
    } catch (_) {
      return 0;
    }
  }

  isCheckboxDisabled(item: any) {
    return item?.is_able_to_booking === false;
  }

  get courierId() {
    return Number(this.$route.params.id || 1);
  }

  get startIndex() {
    return (this.pagination.page - 1) * this.pagination.limit;
  }

  get pagedData() {
    return this.listData;
  }

  mounted() {
    this.$watch(
      () => this.$route.query,
      (_newQ: Record<string, any>, _oldQ: Record<string, any>) => {
        this.pagination.page = 1;
        this.fetchData();
      },
      { deep: false, immediate: true }
    );
  }

  onSort(key: string) {
    if (this.sortBy !== key) {
      this.sortBy = key;
      this.sortDir = "asc";
    } else if (this.sortDir === "asc") {
      this.sortDir = "desc";
    } else {
      this.sortBy = "";
      this.sortDir = "";
    }
    this.fetchData();
  }

  onOpenWa(phone: string) {
    whatsapp(phone);
  }

  formatShipmentType(val: string) {
    if (!val) return "-";
    const lower = String(val).toLowerCase();
    const normalized = lower.replace(/_/g, " ");
    return normalized.replace(/\b\w/g, (l) => l.toUpperCase());
  }

  formatPickupDate(item: any) {
    const date =
      item.pickup_date ||
      item.pickup_at ||
      item.picked_up_at ||
      item.pick_up_date ||
      item.status_at ||
      "";
    if (!date) return "-";
    try {
      const d = new Date(date);
      const day = d.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
      const time = d.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit"
      });
      return `${day}, ${time}`;
    } catch (_) {
      return String(date);
    }
  }

  onSelectToggle(item: any) {
    try {
      const idx = (this.listData || []).findIndex((d: any) => d === item);
      if (idx >= 0) {
        this.listData[idx].is_checked = !this.listData[idx].is_checked;
        this.listData = [...this.listData];
      }
    } catch (_) {
      // ignore
    }
  }

  onToggleSelectAll(checked: boolean) {
    try {
      (this.pagedData || []).forEach((d: any) => {
        if (d?.is_able_to_booking !== false) {
          d.is_checked = checked;
        }
      });
      this.listData = [...this.listData];
    } catch (_) {
      // ignore
    }
  }

  onSetPage(p: number) {
    this.pagination.page = p;
    this.fetchData();
  }

  onTransferPickUpRow(_item: any) {
    // transfer pick up row
  }

  onBulkTransferPickUp() {
    // bulk transfer pick up
    const shipmentIds = (this.listData || [])
      .filter(
        (d: any) => Boolean(d.is_checked) && d?.is_able_to_booking !== false
      )
      .map((d: any) => d.shipment_id)
      .join(",");
    this.$router.push(`/booking-v2/create/by-shipment-id?bulk=${shipmentIds}`);
  }

  onShowProof(item: any) {
    const urls = this.getProofImages(item);
    this.images = urls.map((u: string) => ({ image: u, url: u }));
    this.image = this.images[0]?.image || "";
    this.showImagePreview = true;
  }

  closeImagePreview() {
    this.images = [];
    this.image = "";
    this.showImagePreview = false;
  }

  getProofImages(item: any): string[] {
    const arr = [] as string[];
    const candidates = [
      item.pickup_proof_urls,
      item.pickup_proof,
      item.proofs,
      item.photos,
      item.images
    ];
    for (const c of candidates) {
      if (Array.isArray(c) && c.length)
        return c.filter((u: any) => typeof u === "string");
      if (typeof c === "string" && c) arr.push(c);
    }
    return arr;
  }

  async fetchData() {
    await this.safeRunFetch("CRRPIC");
  }

  get isFiltering() {
    const { q, shipmentType, start, end } = this.getRouteQuery();
    return Boolean(q || shipmentType || start || end);
  }

  private getRouteQuery() {
    const cid = Number(this.$route.params.id || 0);
    const start = String(this.$route.query.start_date || "");
    const end = String(this.$route.query.end_date || "");
    const q = String(this.$route.query.q || "");
    const shipmentType = String(this.$route.query.shipment_type || "");
    return { cid, start, end, q, shipmentType };
  }

  private buildFetchKey(args: {
    cid: number;
    start: string;
    end: string;
    q: string;
    shipmentType: string;
  }) {
    return [
      args.cid,
      args.start,
      args.end,
      args.q,
      args.shipmentType,
      this.pagination.page,
      this.pagination.limit,
      this.sortBy,
      this.sortDir
    ].join("|");
  }

  private isArgsMissing(args: { cid: number; start: string; end: string }) {
    return !args.cid;
  }

  private shouldSkipFetch(key: string) {
    if (this.pendingKey === key) return true;
    if (this.lastFetchKey === key) return true;
    return false;
  }

  private createListRequest(
    status: string,
    args: {
      cid: number;
      start: string;
      end: string;
      q: string;
      shipmentType: string;
    }
  ) {
    return new ShipmentListRequest({
      courierId: args.cid,
      startDate: args.start,
      endDate: args.end,
      status,
      q: args.q,
      shipmentType: args.shipmentType,
      page: this.pagination.page,
      limit: this.pagination.limit,
      sortBy: this.sortDir.toUpperCase(),
      orderBy: this.sortBy
    });
  }

  private updateListFromResponse(res: any) {
    this.listData = Array.isArray(res.data)
      ? res.data.map((d: any) => ({ ...d, is_checked: Boolean(d.is_checked) }))
      : [];
    this.pagination = new Pagination(
      res.pagination.page || this.pagination.page,
      res.pagination.limit || this.pagination.limit,
      res.pagination.totalData || 0
    );
  }

  private async safeRunFetch(status: string) {
    try {
      this.error = "";
      const args = this.getRouteQuery();
      if (this.isArgsMissing(args)) return;
      const key = this.buildFetchKey(args);
      if (this.shouldSkipFetch(key)) return;
      this.isLoading = true;
      this.pendingKey = key;
      this.lastFetchKey = key;
      const params = this.createListRequest(status, args);
      const res = await PickupDashboardController.getShipmentList(params);
      this.updateListFromResponse(res);
    } catch (e) {
      const msg =
        (e as any)?.message || String(this.$t("pickupDashboard.systemError"));
      this.error = msg;
    } finally {
      this.isLoading = false;
      this.pendingKey = "";
      this.readyForUserSort = true;
    }
  }

  onBooking(item: any) {
    const shipmentIds = item.shipment_id;
    this.$router.push(`/booking-v2/create/by-shipment-id?bulk=${shipmentIds}`);
  }

  fmtQty(val: number | string) {
    return formatByCountry(Number(val || 0), { type: "quantity" });
  }

  ellipsis(val: string) {
    return ellipsisString(val, 70);
  }
}
export default PickupDashboardMonitoringCourierDetailCRRPIC;
